import { utilsService } from './services/utils.service';

// 主链
const baseUrl = (window.location.href.match(/^http[^#?]+\//i) || [])[0] || '';

/** 分享地址 */
const shareUrl = (() => {
  let host = 'https://test.thefront.com.cn/bmw.motor18';
  if (/(event)/.test(baseUrl)) host = 'https://bmw-motorrad-r18.fnws.top/';
  return host;
})();

const HOST = (() => {
  let host = 'https://test.thefront.com.cn/bmw.motor18/';
  // if (/(localhost|10.0.0)/.test(baseUrl)) host = 'https://test.thefront.com.cn/RRBoxGame';
  if (/(event)/.test(baseUrl)) host = 'https://bmw-motorrad-r18.fnws.top/';
  return host;
})();

const wxJssdk = (() => {
  let jssdkHost = 'https://w1.thefront.com.cn/weixports/fnws/getwxapi.php';
  // let jssdkHost = 'https://w1.thefront.com.cn/weixports/skoda/getwxapi.php';
  // if (/fnws.top/i.test(baseUrl)) jssdkHost = 'https://api.fnws.top/wxapi/ftcontent';
  return jssdkHost;
})();

const wxApi = (() => {
  let url = 'https://open.weixin.qq.com/connect/oauth2/authorize';
  // if (/fnws.top/i.test(baseUrl)) url = 'https://api.fnws.top/wxapi/ftcards/getwxapi.php';
  return url;
})();

const vod = {
  intro: 'https://vod.fnws.top/sv/1bfe67c-178b171a64e/1bfe67c-178b171a64e.mp4',
};

export const APP_CONFIG = {
  appId: 'wx3d09c0c7879c5a45', // test.fnws.top
  privateKey: '64aVaMI6aRce6h2I',
  // 高德地图api key
  AMapKey: 'e5b36357f1e9e43bdbb8a5eeec15383a',
  /** 分享链接 */
  shareLink: shareUrl,
  /** 网站根路径 */
  baseUrl,
  /** 微信分享接口地址 */
  wxJssdk,
  /** 微信公众号接口地址 */
  wxApi,

  /** vod 视频地址 */
  vod,

  ep: {
    /** 获取用户数据 */
    getUserinfo: `${HOST}client/user`,
    subForm: `${HOST}wechat/user/info`, //留资提交、查询（微信） 留资post、查询get
    wechatSubForm: `${HOST}wechat/user/bind_phone`, //微信用户绑定手机号(微信端)
    websubForm: `${HOST}web/user/info`, //用户留资、查询(浏览器端)  留资post、查询get

    citys: `${HOST}citys`, //获取城市
    questionInfo: `${HOST}wechat/answer/info`, //微信端提交答案
    userInfo: `${HOST}wechat/user/info`, //微信端判定是否有留资
    dealers: `${HOST}dealers`, //获取经销商

    webVerifyCodeSubmit: `${HOST}web/sms/verify_code_for_submit`, //获取留资短信验证码(浏览器端)
    wechatVerifyCodeSubmit: `${HOST}wechat/sms/verify_code_for_submit`, //获取留资短信验证码(微信端)

    webVerifyCodeSearch: `${HOST}web/sms/verify_code_for_search`, // 获取查询短信验证码(浏览器端)
    wechatVerifyCodeBind: `${HOST}wechat/sms/verify_code_for_bind`, // 获取绑定短信验证码(微信端)

    webinfo: `${HOST}web/answer/info`, //已留资用户再次提交答案(浏览器端)
    time: `${HOST}system/time`, //获取系统时间

    jssdkConfig: `${HOST}auth/jssdk_config`, //jssdk信息
  },

  siteName: 'BMW-Motor2021-Frontend',
  version: '1.0.0',
};
